import { useMutation } from '@tanstack/react-query';

export interface GenerateMealPlanSummaryParams {
  dailyRoomName: string;
  healthieClientId?: number;
  healthieProviderId?: number;
}

const generateMealPlanSummary = async (
  params: GenerateMealPlanSummaryParams,
): Promise<void> => {
  const { dailyRoomName, healthieClientId, healthieProviderId } = params;

  const queryParams = new URLSearchParams();
  if (healthieClientId)
    queryParams.set('healthieClientId', String(healthieClientId));
  if (healthieProviderId)
    queryParams.set('healthieProviderId', String(healthieProviderId));
  const qs = queryParams.toString();

  const res = await fetch(
    `/api/meal-plan/${dailyRoomName}/generate-meal-plan-summary${qs ? `?${qs}` : ''}`,
    {
      method: 'POST',
    },
  );

  if (!res.ok) {
    return Promise.reject('Failed to generate meal plan summary');
  }

  return res.json();
};

export const useGenerateMealPlanSummary = () =>
  useMutation({
    mutationFn: (params: GenerateMealPlanSummaryParams) =>
      generateMealPlanSummary(params),
  });
